import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

export default class extends Controller {
  static values = { targetId: String }

  connect() {
    if (!this.hasTargetIdValue || this.targetIdValue.length === 0) return

    const offcanvasElement = document.getElementById(this.targetIdValue)
    if (!offcanvasElement) return

    Offcanvas.getOrCreateInstance(offcanvasElement).show()
  }
}
